// Entry point for the pubsite demos bundle.
// Bundled by esbuild as IIFE so `toggleMobileMenu`/`closeMobileMenu` can be
// attached to `window` for inline `onclick=` handlers in index_raw.html.

import { exposeMobileMenuGlobals } from "./pubsite-demos/mobile-menu.js";
import { initScrollReveal } from "./pubsite-demos/scroll-reveal.js";
import { initEvidenceTabs } from "./pubsite-demos/evidence-tabs.js";
import { initDataLayerSearchDemo } from "./pubsite-demos/data-layer-search.js";
import { initMcpChatDemo } from "./pubsite-demos/mcp-chat.js";
import { INDEX_CYCLES } from "./pubsite-demos/mcp-chat-cycles-index.js";
import { GEOX_CYCLES } from "./pubsite-demos/mcp-chat-cycles-geox.js";
import { QTLX_CYCLES } from "./pubsite-demos/mcp-chat-cycles-qtlx.js";
import { GWASX_CYCLES } from "./pubsite-demos/mcp-chat-cycles-gwasx.js";
import type { ChatCycle } from "./pubsite-demos/types.js";

exposeMobileMenuGlobals();

function pickMcpCycles(): ChatCycle[] | null {
  const root = document.getElementById("mcp-chat-demo");
  if (!root) return null;
  const page = root.dataset.page;
  if (page === "geox") return GEOX_CYCLES;
  if (page === "qtlx") return QTLX_CYCLES;
  if (page === "gwasx") return GWASX_CYCLES;
  // Default to the index cycles for back-compat with any page that omits the
  // attribute. Pages should still set data-page explicitly.
  return INDEX_CYCLES;
}

document.addEventListener("DOMContentLoaded", () => {
  initScrollReveal();
  initEvidenceTabs();
  initDataLayerSearchDemo();
  const cycles = pickMcpCycles();
  if (cycles) initMcpChatDemo(cycles);
});
